import { render } from "./index.vue?vue&type=template&id=6341b337&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=6341b337&scoped=true&lang=css"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6341b337"]])

export default __exports__